import { useState, useEffect } from 'react'
import api from '../api'
import { lang, sendMail } from '../lang'
import classes from '../../assets/css/form.module.css';

export default function AssistantBooking(props) {
	const today = new Date().toISOString().split('T')[0];
    const email = localStorage.getItem("email");
    const [id, setID] = useState(0);
    const [all_events, setAllEvents] = useState([]);
    const [assistant_id, setAssistantID] = useState(0);
    const [booking_date, setBookingDate] = useState(today);
    const [booking_by, setBookingBy] = useState('');
    const [booking_email, setBookingEmail] = useState(email);
    const [os_id, setOsID] = useState('');
    const [note, setNote] = useState('');
    const {assistants} = props;
    const [error, setError] = useState(0);
    const [success, setSuccess] = useState(0);
    const [msg, setMsg] = useState('');
    const [os_lists, setOsLists] = useState([]);
    const [assistant_lists, setAssistantLists] = useState([]);
    const time_lists = ['09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00'];
    const [start_times, setStartTimes] = useState(time_lists);
    const [start_time, setStartTime] = useState('09:00');
    const [end_time, setEndTime] = useState('10:00');

        

    const fetchInit = async () =>{
        try {
            const resp = await api.get('/assistant-bookings/os-list');
            setOsLists(resp.data.results);
            const asst_resp = await api.get('/assistants?get_all=1');
            setAssistantLists(asst_resp.data.results);
            let asst_id = assistant_lists[0].id||0;
            let times = [];
            // check start_times for current assistant
            assistant_lists.forEach((asst)=>{
                if(asst_id===0){
                    asst_id = asst.id;
                }
                if(parseInt(asst.id)===parseInt(assistant_id)){
                    let available_lists = asst.available_lists;
                    available_lists.forEach((item)=>{
                        // item.booking_date between start_date and end_date
                        if(parseInt(item.is_available)===1&&new Date(item.start_date)<=new Date(booking_date)&&new Date(item.end_date)>=new Date(booking_date)){
                            let start_time = parseInt(item.start_time.split(':')[0]);
                            let end_time = parseInt(item.end_time.split(':')[0]);
                            // item.start_time and item.end_time
                            time_lists.forEach((time)=>{
                                let hr = parseInt(time.split(':')[0]);
                                if(hr>=start_time&&hr<end_time){
                                    if(!times.includes(time)){
                                        times.push(time);
                                    }
                                }
                            });

                        }
                    });
                }
            });
            setAssistantID(asst_id);
            setStartTimes(times);
            setStartTime(times[0]);
            setEndTime(times[1]);
        } catch (err) {
            if(err.response){
                //Not in 202 response range
                console.log(err.response.data);
                console.log(err.response.headers);
                console.log(err.response.status);
            } else {
                console.log(`Error: ${err.message}`);
            }
        }
    }

    useEffect(()=>{
        fetchInit();
    },[]);

    useEffect(()=>{
        if(!email){
            window.location = process.env.PUBLIC_URL + '/rsvn?menu=login';
        }

        let cmu_account = JSON.parse(localStorage.getItem("cmu_account"));
        if(cmu_account){
            if(cmu_account.name){
                setBookingBy(cmu_account.name);
            }else{
                setBookingBy(cmu_account.prename_TH+' '+cmu_account.firstname_TH+' '+cmu_account.lastname_TH);
            }
            setBookingEmail(cmu_account.email);
        }
        fetchInit();
    },[]);

    const isHoliday = (event_date) => {
        const filterEvent = all_events?.filter((element: any) => {
            // console.log(new Date(element.start).toISOString().split('T')[0]);
            if((new Date(event_date).getTime() <= new Date(element.end).getTime() && new Date(event_date).getTime() >= new Date(element.start).getTime())) {
                return element.type === 'holiday' 
            }
        });

        if(filterEvent?.length>0){
            return true;
        }else{
            return false;
        }

    }

    function isBetween(h,m, h1, m1, h2, m2,state,room) {
        // console.log('check: '+room+' '+state+' : '+h+':'+m+','+h1+':'+m1+','+h2+':'+m2);
        if(state==="start"){
            return (h1 < h || (h1 === h && m1 <= m)) && (h < h2 || (h === h2 && m < m2));
        }else{
            return (h1 < h || (h1 === h && m1 < m)) && (h < h2 || (h === h2 && m <= m2));
        }
    }

    const isWeekEnd = (event_date) => {
        var dayOfWeek = new Date(event_date).getDay();
        if((dayOfWeek === 6) || (dayOfWeek  === 0)){
            return true;
        }else{
            return false;
        }

    }
    
    const isEmpty = () => {
        const filterEvent = all_events?.filter((element: any) => {
            if((id===0 || element.item.id !== id)&&element.start.split('T')[0]===booking_date&& parseInt(element.item.assistant_id)===parseInt(assistant_id)){
            let [start_hr,start_min] = element.start.split('T')[1].split(':');
            let [end_hr,end_min] = element.end.split('T')[1].split(':');
            let [hr,min] = start_time.split(':');
            let [hr2,min2] = end_time.split(':');
            // console.log(element.item.room_id+'  : '+hr+':'+min+','+start_hr+':'+start_min+','+end_hr+':'+end_min);
            // console.log(isBetween(hr,min,start_hr,start_min,end_hr,end_min,"start",element.item.room_name))
            // console.log(isBetween(hr2,min2,start_hr,start_min,end_hr,end_min,"end",element.item.room_name))

            return (isBetween(hr,min,start_hr,start_min,end_hr,end_min,"start",element.item.room_name)||
                        isBetween(hr2,min2,start_hr,start_min,end_hr,end_min,"end",element.item.room_name));
            }
        });
        // console.log(assistant_id,filterEvent);

        if(filterEvent?.length>0){
            return false;
        }else{
            return true;
        }

    }

    function handleSubmit(event){
        event.preventDefault();
        setError(0);
        setSuccess(0);
        setMsg('');
        if(!booking_date){
            let message = lang('กรุณากรอกวันที่นัดหมาย..','Please enter Booking Date..');
            setError(1);
            setMsg(message);
            return
        }else if(!start_time){
            let message = lang('กรุณากรอกเวลาเริ่มต้น..','Please enter Start Time..');
            setError(1);
            setMsg(message);
            return
        }else if(!isEmpty()){
            let message = lang('ไม่สามารถนัดหมายในเวลานี้ได้..','Can\'t make a reservation at this time..');
            setError(1);
            setMsg(message);
            return
        }else if(!assistant_id){
            let message = lang('กรุณาเลือกผู้สอน..','Please enter Assistant ID..');
            setError(1);
            setMsg(message);
            return
        }else if(isHoliday(booking_date)){
            let message = lang('ไม่สามารถนัดหมายในวันนี้ได้เนื่องจากเป็นวันหยุด..','Can\'t make a reservation at today..');
            setError(1);
            setMsg(message);
            return
        }else if(isWeekEnd(booking_date)){
            let message = lang('ไม่สามารถนัดหมายในวันนี้ได้เนื่องจากเป็นวันหยุด..','Can\'t make a reservation at today..');
            setError(1);
            setMsg(message);
            return
        }else{
            // create new booking
            const user=localStorage.getItem('email');
            const ip=localStorage.getItem('ip');
            // console.log("create new booking");
            const jsonData = {
                assistant_id: assistant_id,
                booking_date: booking_date,
                start_time: start_time,
                end_time: end_time,
                booking_by: booking_by,
                booking_email: user,
                os_id: os_id,
                note: note,
                status: "confirmed",
                user: user,
                ip: ip,
            } 
            api.post(`assistant-bookings`,jsonData)
            .then(response => {
                if(response.data.status==='ok'){
                    setSuccess(1);
                    fetchInit();
                }else{
                    setError(1);
                    let message = JSON.stringify(response.data.message);
                    setMsg(message);
                }
            })
            .catch(error => {
                setError(1);
                setMsg(error);
            });
        }
    }

    const send_mail = async (event, id, type) => {
        try {
            let subject = 'การนัดหมายตรวจรายงาน';
            if(type==="update"){
                subject = 'การแก้ไขนัดหมายตรวจรายงาน';
            }
            const assistantName = assistant_lists.find(a => parseInt(a.id) === parseInt(assistant_id))?.name || assistant_id;
            const assistantEmail = assistant_lists.find(a => parseInt(a.id) === parseInt(assistant_id))?.email || assistant_id;
            const osName = os_lists.find(o => parseInt(o.id) === parseInt(os_id))?.name || os_id;
            const body = `<html><body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;"><div style="max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #ddd; border-radius: 10px;"><h2 style="color:#dc3545; text-align:center">&#128197; ${subject}</h2><div style="background-color:#b9f8cf; padding:10px; border-radius:5px; margin:15px 0"><p style="margin:0; font-weight:bold; color:#0d542b">⚠️ มี${(type==="update")?"การนัดหมายตรวจรายงานใหม่":"การแก้ไขนัดหมายตรวจรายงาน"} เว็บไซต์ห้องสมุดคณะสัตวแพทย์ </p></div><table style="width:100%; border-collapse:collapse; margin:20px 0"><tbody><tr style="background-color:#f8f9fa"><td style="padding:10px; border:1px solid #ddd; font-weight:bold; width:30%">รหัสการนัดหมาย</td><td style="padding:10px; border:1px solid #ddd">#${id}</td></tr><tr><td style="padding:10px; border:1px solid #ddd; font-weight:bold">&#128101; ผู้สอน</td><td style="padding:10px; border:1px solid #ddd">${assistantName}</td></tr><tr style="background-color:#f8f9fa"><td style="padding:10px; border:1px solid #ddd; font-weight:bold">&#128197; วันที่นัดหมาย</td><td style="padding:10px; border:1px solid #ddd">${booking_date}</td></tr><tr><td style="padding:10px; border:1px solid #ddd; font-weight:bold">&#9200; เวลา</td><td style="padding:10px; border:1px solid #ddd">${start_time} - ${end_time} น.</td></tr><tr style="background-color:#f8f9fa"><td style="padding:10px; border:1px solid #ddd; font-weight:bold">&#128100; นัดหมายโดย</td><td style="padding:10px; border:1px solid #ddd; font-weight:bold; color:#dc3545">${booking_by}</td></tr><tr><td style="padding:10px; border:1px solid #ddd; font-weight:bold; vertical-align:top">&#128140; อีเมล์</td><td style="padding:10px; border:1px solid #ddd; white-space:pre-wrap">${booking_email}</td></tr><tr style="background-color:#f8f9fa"><td style="padding:10px; border:1px solid #ddd; font-weight:bold">&#128187; ระบบปฏิบัติการ</td><td style="padding:10px; border:1px solid #ddd">${osName}</td></tr> ${note ? `<tr><td style="padding:10px; border:1px solid #ddd; font-weight:bold">&#128221; รายละเอียด</td><td style="padding:10px; border:1px solid #ddd">${note}</td></tr>` : ''}</tbody></table><div style="background-color:#d1ecf1; padding:15px; border-radius:5px; margin:20px 0"><p style="margin:0; color:#0c5460"><strong>📌 หมายเหตุ:</strong><br>กรุณาเข้าสู่ระบบเพื่อตรวจสอบและดำเนินการต่อไป</p></div><hr style="margin:20px 0; border:none; border-top:1px solid #ddd"><p style="font-size:12px; color:#666; text-align:center">เว็บไซต์ห้องสมุดคณะสัตวแพทย์ มหาวิทยาลัยเชียงใหม่<br>อีเมลนี้ส่งโดยระบบอัตโนมัติ </p></div></body></html>`;
            // const email = booking_email;
            const email = "u4706264@gmail.com";
            const resp = await sendMail(subject, body, email);
            if(resp && resp.status===true){
                setSuccess(1);
                fetchInit();
            }else{
                setError(1);
                setMsg(resp?.message || 'Failed to send email');
            }    
        } catch (error) {
            setError(1);
            setMsg(error);
        }
    }

    const checkData = (value,state) => {
        setError(0);
        setMsg('');
        let times = [];
        let check_booking_date = (state==="booking_date")?value:booking_date;
        let check_assistant_id = (state==="assistant_id")?value:assistant_id;
        // check start_times for current assistant
        assistant_lists.forEach((asst)=>{
            if(parseInt(asst.id)===parseInt(check_assistant_id)){
                let available_lists = asst.available_lists;
                available_lists.forEach((item)=>{
                    // item.booking_date between start_date and end_date
                    if(parseInt(item.is_available)===1&&new Date(item.start_date)<=new Date(check_booking_date)&&new Date(item.end_date)>=new Date(check_booking_date)){
                        let start_time = parseInt(item.start_time.split(':')[0]);
                        let end_time = parseInt(item.end_time.split(':')[0]);
                        // item.start_time and item.end_time
                        time_lists.forEach((time)=>{
                            let hr = parseInt(time.split(':')[0]);
                            if(hr>=start_time&&hr<end_time){
                                if(!times.includes(time)){
                                    times.push(time);
                                }
                            }
                        });

                    }
                });
            }
        });
        setStartTimes(times);
        if(times.length===0){
            let message = lang('ไม่สามารถนัดหมายในวันนี้ได้เนื่องจากไม่ใช่ช่วงเวลาที่สามารถเปิดสอน..','Can\'t make a reservation at today..');
            setError(1);
            setMsg(message);
        }
        if(state==="booking_date"){
            setBookingDate(value);
            // check assistant availability and holiday
            if(isHoliday(value)){
                let message = lang('ไม่สามารถนัดหมายในวันนี้ได้เนื่องจากเป็นวันหยุด..','Can\'t make a reservation at today..');
                setError(1);
                setMsg(message);
                return
            }else if(isWeekEnd(value)){
                let message = lang('ไม่สามารถนัดหมายในวันนี้ได้เนื่องจากเป็นวันหยุด..','Can\'t make a reservation at today..');
                setError(1);
                setMsg(message);
                return
            }
            setStartTime(times[0]);
            setEndTime(times[1]);
        }else if(state==="assistant_id"){
            setAssistantID(value);
            setStartTime(times[0]);
            setEndTime(times[1]);
        }
    }

    const updateTimeList = (state,time) => {
        if(state === 'start'){
            setStartTime(time);

            setEndTime(current=>{
                return time_lists[time_lists.indexOf(time)+1];
            })
        } else if(state === 'end'){
            setEndTime(time);
        }
    }

    return (
        <div>
            <h3>
                {lang("นัดหมายตรวจการบ้าน","Assistant Booking")}
            </h3>
            <div className={classes["booking-form"]}>
                {(error===1)?(
                    <div className="notice danger">
                        <div><i className="fa-solid fa-triangle-exclamation"></i></div>
                        <div className="info">
                            <b>{lang('ไม่สามารถบันทึกข้อมูลได้','Can\'t booking..')}</b><br />
                            {msg}
                        </div>
                    </div>
                    ):''}
                {(success===1)?(
                <div className="notice active">
                    <div><i className="fa-regular fa-file-lines"></i></div>
                    <div className="info">
                        <b>{lang('บันทึกข้อมูลเรียบร้อย!','Successfuly!')}</b>
                        <br />{lang('ทำรายการบันทึกข้อมูลเรียบร้อย..','Complete booking!')}
                    </div>
                    <div>
                        <i className="fa-solid fa-xmark btn-close" onClick={(event)=>setSuccess(0)}></i>
                    </div>
                </div>
                ):''}
                <form className={classes["main-form"]}>
                    <fieldset>
                        <label htmlFor="assistant_id">{lang('ผู้สอน','Assistant')}</label>
                        <select name="assistant_id" id="assistant_id" value={(assistant_id)?assistant_id:0} onChange={e=>checkData(e.target.value, "assistant_id")}>
                            {assistants.map((option,index) => (
                                <option value={option.id} key={'assistant-'+index}>{option.name}</option>
                            ))}
                        </select>
                    </fieldset>
                    <fieldset>
                        <label htmlFor="booking_date">{lang('วันที่นัดหมาย','Booking Date')}</label>
                        <input type="date" name="booking_date" id="booking_date" value={(booking_date)?booking_date:''} onChange={e=>checkData(e.target.value,"booking_date")} required />
                    </fieldset>
                    {(start_times.length===0)?'':(
                    <>
                    <fieldset>
                        <label htmlFor="start_time">{lang('เวลาเริ่มต้น','Start Time')}</label>
                        <select name="start_time" id="start_time" value={(start_time)?start_time:0} onChange={e=>updateTimeList('start',e.target.value)}>
                            {start_times.map((option,index) => (
                                <option value={option} key={'start-'+index}>{option}</option>
                            ))}
                        </select>
                    </fieldset>
                    <fieldset>
                        <label htmlFor="end_time">{lang('เวลาสิ้นสุด','End Time')}</label>
                        <input type="text" name="end_time" id="end_time" value={(end_time)?end_time:''} readOnly />
                    </fieldset>
                    <fieldset className={classes["hide"]}>
                        <label htmlFor="booking_by">{lang('นัดหมายโดย','Booking By')}</label>
                        <input type="text" name="booking_by" id="booking_by" value={(booking_by)?booking_by:''} onChange={e=>setBookingBy(e.target.value)} required />
                    </fieldset>
                    <fieldset className={classes["hide"]}>
                        <label htmlFor="booking_email">{lang('อีเมล์ผู้นัดหมาย','Email')}</label>
                        <input type="text" name="booking_email" id="booking_email" value={(booking_email)?booking_email:''} onChange={e=>setBookingEmail(e.target.value)} required />
                    </fieldset>
                    <fieldset>
                        <label htmlFor="os_id">{lang('ระบบปฏิบัติการ','Operating System')}</label>
                        <select name="os_id" id="os_id" value={(os_id)?os_id:1} onChange={e=>setOsID(e.target.value)}>
                        {os_lists.map((os) => (
                            <option key={os.id} value={os.id}>
                            {os.name}
                            </option>
                        ))}
                        </select>
                    </fieldset>
                    <fieldset>
                        <label htmlFor="note">{lang('หมายเหตุ','Note')}</label>
                        <textarea name="note" id="note" value={(note)?note:''} onChange={e=>setNote(e.target.value)}></textarea>
                    </fieldset>
                    <fieldset>
                        <button onClick={e=>handleSubmit(e)} className={classes["btn"]}>{lang('จองห้อง','Make booking')}</button>
                    </fieldset>
                    </>
                    )}
                </form>
            </div>
        </div>
    )
}
